import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const useAdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const loadUsers = async (isMounted = true) => {
    setLoading(true);
    setError("");
    try {
      const response = await api.get("/admin/users");
      if (isMounted) setUsers(response.data);
    } catch (loadError) {
      if (!isMounted) return;
      setError(loadError.response?.status === 403 ? "Admin access is required." : "Unable to load users right now.");
    } finally {
      if (isMounted) setLoading(false);
    }
  };

  useEffect(() => {
    let isMounted = true;

    loadUsers();
    return () => {
      isMounted = false;
    };
  }, []);

  return { error, loading, reloadUsers: () => loadUsers(true), users };
};